import type { Filters } from 'src/store/models/SearchModels'
import { ListItem } from './interfaces'
import type { AppliedFilterChipDescriptor } from './types'

export const applyStagedFilterChange = (
  filterName: string,
  selectedOptions: ListItem[],
  currentFilters: Filters,
  clearExisting = false
): Filters => {
  const newFilters = clearExisting
    ? []
    : currentFilters.filter((entry) => entry.groupName !== filterName)
  if (selectedOptions.length > 0) {
    newFilters.push({
      groupName: filterName,
      items: selectedOptions.map((option) => option.value.toString()),
    })
  }
  return newFilters
}

export const removeStagedChip = (
  chip: AppliedFilterChipDescriptor,
  filters: Filters,
  manufacturers: string[]
): { filters: Filters; manufacturers: string[] } => {
  if (chip.kind === 'manufacturer' && chip.value) {
    return {
      filters,
      manufacturers: manufacturers.filter(
        (manufacturer) => manufacturer !== chip.value
      ),
    }
  }

  if (chip.kind === 'facet' && chip.groupName && chip.value) {
    const group = filters.find((entry) => entry.groupName === chip.groupName)
    if (!group) {
      return { filters, manufacturers }
    }
    const items = group.items.filter((item) => item !== chip.value)
    if (items.length === 0) {
      return {
        filters: filters.filter((entry) => entry.groupName !== chip.groupName),
        manufacturers,
      }
    }
    return {
      filters: filters.map((entry) =>
        entry.groupName === chip.groupName ? { ...entry, items } : entry
      ),
      manufacturers,
    }
  }

  return { filters, manufacturers }
}
